import { CheckoutState } from '../state';
import { getIsEnableEBMarketingOptInImplicitFF } from './app';
import { isOrganizerInitiatedTransferOrder } from './order';
import { isAddAttendeesOrder } from './order/typedOrderSelectors';

export const shouldInitializeEBMarketingOptIn = (state: CheckoutState) =>
    !isAddAttendeesOrder(state) &&
    !isOrganizerInitiatedTransferOrder(state) &&
    getIsEnableEBMarketingOptInImplicitFF(state);
